import React from 'react'
import styles from './horizontalcheckbox.module.scss'

const HorizontalCheckBox = (props) => {
    const { fieldInfo, value, onChange } = props
    return <div className={styles.main}>
        {fieldInfo.options.map(option => (
            <div key={option.name}
                 className={option?.label === value ? styles.optionDivSelected : styles.optionDiv}
                 onClick={(e) => onChange(option?.label)}>
                {option.label}
            </div>
        ))}
    </div>
}


export default HorizontalCheckBox
